// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"8bce0157","640":"5f7e7664","656":"ef6beb59","734":"0df69cc3","787":"4c6a7659","884":"3c3ac9c4","968":"65453590"}[chunkId] + ".chunk.js";
};